import {ListModel, TimestampsModel} from "../common";

export enum KnowledgeBaseDocumentTypeModel {
  TEXT = "text",
  LINK = "link",
  FILE = "file",
}

export type KnowledgeBaseDocumentRecordModel = TimestampsModel<false, true> & {
  slug: string;
  name: string;
  type: KnowledgeBaseDocumentTypeModel;
  url?: string;
};

export type KnowledgeBaseDocumentListModel =
  ListModel<KnowledgeBaseDocumentRecordModel>;

export type KnowledgeBaseDocumentCreateModel = {
  slug: string;
  data: {
    name: string;
    type: KnowledgeBaseDocumentTypeModel;
    url?: string;
    content?: string;
  };
};

export type KnowledgeBaseDocumentDetailedModel =
  KnowledgeBaseDocumentRecordModel & {
    // INFO: detailed model is only for blank document, the other types open the URL in new tab
    text: string;
  };
